import { useState } from 'react'

import { Box, Button, Grid, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import RequestUpgradeModal from 'modules/upsell/components/RequestUpgradeModal'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'

const UpgradePlanBanner: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const Ellipse1 = (
    <Box
      background="promoteBackgroundSubtle"
      style={{
        width: '25vw',
        height: '22vh',
        position: 'absolute',
        borderRadius: '50%',
        top: '-130px',
        left: '0px',
        filter: 'blur(58px)',
        opacity: '1',
        transform: 'rotate(-176deg)',
      }}
    />
  )

  const Ellipse2 = (
    <Box
      background="promoteBackgroundSubtle"
      style={{
        width: '25vw',
        height: '22vh',
        position: 'absolute',
        borderRadius: '50%',
        bottom: '-130px',
        right: '0px',
        filter: 'blur(58px)',
        opacity: '1',
        transform: 'rotate(-176deg)',
      }}
    />
  )

  return (
    <>
      <Box
        boxShadow="s100"
        borderRadius={{ all: 'abs008' }}
        background="white"
        padding="s40"
        paddingX="s64"
        style={{
          position: 'relative',
          overflow: 'hidden',
          marginBottom: '24px',
        }}
      >
        {Ellipse1}
        {Ellipse2}

        <Box
          gap="s8"
          style={{ zIndex: '1' }}
          paddingBottom="s24"
          justifyContent="center"
          alignItems="center"
          textAlign="center"
        >
          <Text.Header1 htmlTag="h2">
            {i18n.t('upsell_page.upgrade_legacy_page.title')}{' '}
            {i18n.t('upsell_page.upgrade_legacy_page.sub_title')}
          </Text.Header1>
          <Text.Normal htmlTag="p">
            {i18n.t('upsell_page.upgrade_legacy_page.paragraph')}
          </Text.Normal>
        </Box>

        <Grid variant="fixed">
          <Box flexDirection="row" gap="s24" gridColSpan={{ xxs: 6 }}>
            <Box flexNoShrink>
              <Icon.Large icon="add-block" color="actionPromoteIcon" />
            </Box>
            <Box flexDirection="column" gap="s8">
              <Text.Header3 htmlTag="h3">
                {i18n.t(
                  'upsell_page.upgrade_legacy_page.features_section.overtime_compensation.title'
                )}
              </Text.Header3>
              <Text.Normal htmlTag="p" size="200">
                {i18n.t(
                  'upsell_page.upgrade_legacy_page.features_section.overtime_compensation.description'
                )}
              </Text.Normal>
            </Box>
          </Box>
          <Box flexDirection="row" gap="s24" gridColSpan={{ xxs: 6 }}>
            <Box flexNoShrink>
              <Icon.Large icon="schedule" color="actionPromoteIcon" />
            </Box>
            <Box flexDirection="column" gap="s8">
              <Text.Header3 htmlTag="h3">
                {i18n.t('upsell_page.upgrade_legacy_page.features_section.coverage_view.title')}
              </Text.Header3>
              <Text.Normal htmlTag="p" size="200">
                {i18n.t(
                  'upsell_page.upgrade_legacy_page.features_section.coverage_view.description'
                )}
              </Text.Normal>
            </Box>
          </Box>
          <Box flexDirection="row" gap="s24" gridColSpan={{ xxs: 6 }}>
            <Box flexNoShrink>
              <Icon.Large icon="documents-folder" color="actionPromoteIcon" />
            </Box>
            <Box flexDirection="column" gap="s8">
              <Text.Header3 htmlTag="h3">
                {i18n.t(
                  'upsell_page.upgrade_legacy_page.features_section.documents_templates.title'
                )}
              </Text.Header3>
              <Text.Normal htmlTag="p" size="200">
                {i18n.t(
                  'upsell_page.upgrade_legacy_page.features_section.documents_templates.description'
                )}
              </Text.Normal>
            </Box>
          </Box>
          <Box flexDirection="row" gap="s24" gridColSpan={{ xxs: 6 }}>
            <Box flexNoShrink>
              <Icon.Large icon="password-lock" color="actionPromoteIcon" />
            </Box>
            <Box flexDirection="column" gap="s8">
              <Text.Header3 htmlTag="h3">
                {' '}
                {i18n.t('upsell_page.upgrade_legacy_page.features_section.blocked_periods.title')}
              </Text.Header3>
              <Text.Normal htmlTag="p" size="200">
                {i18n.t(
                  'upsell_page.upgrade_legacy_page.features_section.blocked_periods.description'
                )}
              </Text.Normal>
            </Box>
          </Box>
        </Grid>
        <Box
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          gap="s24"
          paddingTop="s24"
          style={{ zIndex: '1' }}
        >
          <Box maxWidth="s600" paddingBottom="s16" textAlign="center">
            <Text.Normal htmlTag="p">
              {i18n.t('upsell_page.upgrade_legacy_page.footer.description')}
            </Text.Normal>
          </Box>
          <Button type="upgrade" iconName="crown" onClick={() => setIsModalOpen(true)}>
            {i18n.t('upsell_page.upgrade_legacy_page.cta_text')}
          </Button>
        </Box>
      </Box>
      {isModalOpen && (
        <RequestUpgradeModal
          requestReason={ValidReasons.UpgradeFromLegacy}
          requestSource="marketplace-legacy-apps"
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  )
}

export default UpgradePlanBanner
